import storge from "../../utils/storage"
const homeRoute = {
    meta: { title: "工作台" },
    name: "home",
    path: "/home",
    title: "工作台"
}
const tagsView = {
    state: {
        visitedViews: [],
        cachedViews: []
    },
    mutations: {
        ADD_VISITED_VIEW: (state, view) => {
            let pass = state.visitedViews.some(v => v.path === view.path)
            let passMenus = ["/accountSets"]
            if (pass && passMenus.indexOf(view.path) === -1) return
            if (passMenus.indexOf(view.path) > -1) {
                let isEdit = view.query.hasOwnProperty('id')
                state.visitedViews.forEach(v => {
                    if (v.path === view.path) {
                        v.title = (isEdit ? '编辑' : '新增') + view.meta.title || '';
                    }
                });
                if (pass) return
                const { name, path, meta } = view
                state.visitedViews.push(
                    Object.assign({}, { name, path, meta}, {
                        title: (isEdit ? '编辑' : '新增') + view.meta.title || '',
                        query: isEdit ? view.query : {}
                    })
                )

            } else {
                const { name, path } = view
                state.visitedViews.push(
                    Object.assign({}, { name, path }, {
                        title: view.meta.title || ''
                    })
                )
            }

        },
        ADD_CACHED_VIEW: (state, view) => {
            if (state.cachedViews.includes(view.name)) return
            if (!view.meta.noCache) {
                state.cachedViews.push(view.name)
            }
        },

        DEL_VISITED_VIEW: (state, view) => {
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    state.visitedViews.splice(i, 1)
                    break
                }
            }
        },
        DEL_CACHED_VIEW: (state, view) => {
            for (const i of state.cachedViews) {
                if (i === view.name) {
                    const index = state.cachedViews.indexOf(i)
                    state.cachedViews.splice(index, 1)
                    break
                }
            }
        },

        DEL_OTHERS_VISITED_VIEWS: (state, view) => {
            let result = []
            for (let i = 0; i < state.visitedViews.length; i++) {
                const v = state.visitedViews[i];
                if (v.name == 'home' || v.path === view.path) {
                    result.push(v)
                }
            }
            state.visitedViews = result
        },
        DEL_OTHERS_CACHED_VIEWS: (state, view) => {
            let result = []
            for (let i = 0; i < state.cachedViews.length; i++) {
                const v = state.cachedViews[i];
                if (v.name == 'home' || v.path === view.path) {
                    state.cachedViews.splice(i, 1)
                }
            }
            state.cachedViews = result
        },

        DEL_ALL_VISITED_VIEWS: state => {
            state.visitedViews = [homeRoute]
        },
        DEL_ALL_CACHED_VIEWS: state => {
            state.cachedViews = [homeRoute]
        },

        UPDATE_VISITED_VIEW: (state, view) => {
            for (let v of state.visitedViews) {
                if (v.path === view.path) {
                    v = Object.assign(v, view)
                    break
                }
            }
        },
        SET_VISITED_VIEW: (state, dat) => {

            state.visitedViews = dat
        }

    },
    actions: {
        addView({ dispatch, state }, view) {
            dispatch('addVisitedView', view)
            dispatch('addCachedView', view)
            let dat = []
            state.visitedViews.forEach((v) => {
                dat.push({
                    path: v.path,
                    meta: v.meta,
                    query: v.query,
                    name: v.name,
                    fullPath: v.fullPath,
                    hash: v.hash,
                    params: v.params,
                    title: v.title
                })
            })
        },
        addVisitedView({ commit }, view) {
            commit('ADD_VISITED_VIEW', view)
        },
        addCachedView({ commit }, view) {
            commit('ADD_CACHED_VIEW', view)
        },

        delView({ dispatch, state }, view) {
            return new Promise(resolve => {
                dispatch('delVisitedView', view)
                dispatch('delCachedView', view)
                resolve({
                    visitedViews: [...state.visitedViews],
                    cachedViews: [...state.cachedViews]
                })
            })
        },
        delVisitedView({ commit, state }, view) {
            return new Promise(resolve => {
                commit('DEL_VISITED_VIEW', view)
                resolve([...state.visitedViews])
            })
        },
        delCachedView({ commit, state }, view) {
            return new Promise(resolve => {
                commit('DEL_CACHED_VIEW', view)
                resolve([...state.cachedViews])
            })
        },

        delOthersViews({ dispatch, state }, view) {
            return new Promise(resolve => {
                dispatch('delOthersVisitedViews', view)
                dispatch('delOthersCachedViews', view)
                resolve({
                    visitedViews: [...state.visitedViews],
                    cachedViews: [...state.cachedViews]
                })
            })
        },
        delOthersVisitedViews({ commit, state }, view) {
            return new Promise(resolve => {
                commit('DEL_OTHERS_VISITED_VIEWS', view)
                resolve([...state.visitedViews])
            })
        },
        delOthersCachedViews({ commit, state }, view) {
            return new Promise(resolve => {
                commit('DEL_OTHERS_CACHED_VIEWS', view)
                resolve([...state.cachedViews])
            })
        },

        delAllViews({ dispatch, state }, view) {
            return new Promise(resolve => {
                dispatch('delAllVisitedViews', view)
                dispatch('delAllCachedViews', view)
                resolve({
                    visitedViews: [...state.visitedViews],
                    cachedViews: [...state.cachedViews]
                })
            })
        },
        delAllVisitedViews({ commit, state }) {
            return new Promise(resolve => {
                commit('DEL_ALL_VISITED_VIEWS')
                resolve([...state.visitedViews])
            })
        },
        delAllCachedViews({ commit, state }) {
            return new Promise(resolve => {
                commit('DEL_ALL_CACHED_VIEWS')
                resolve([...state.cachedViews])
            })
        },

        updateVisitedView({ commit }, view) {
            commit('UPDATE_VISITED_VIEW', view)
        },
        setVisitedView({ commit }, dat) {
            commit('SET_VISITED_VIEW', dat)
        }
    }
}

export default tagsView


// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js